import { createSlice } from '@reduxjs/toolkit';
import eventApi from 'services/eventApi';

const initialState = {
  count: 0,
};

const pendingApprovalsSlice = createSlice({
  name: 'pendingApprovals',
  initialState,
  reducers: {
    pendingApprovalsCountSet(state, action) {
      state.count = action.payload;
    },
  },
});

export const { pendingApprovalsCountSet } = pendingApprovalsSlice.actions;

export const fetchPendingApprovalsCount = () => async (dispatch) => {
  try {
    const response = await eventApi.getPendingApprovals();
    dispatch(pendingApprovalsCountSet(response.data.data.length));
  } catch (error) {
    // Non-admins / logged-out users will 401-403 here on a page they can't see anyway - ignore.
    console.error('Error fetching pending approvals count:', error);
  }
};

const pendingApprovalsReducer = pendingApprovalsSlice.reducer;
export default pendingApprovalsReducer;
